import React, { useState, useEffect, useCallback } from 'react';
import { Table, Message } from '@b-design/fusion';
import { Divider } from '@alifd/next';
import $i18n from '@/i18n';
import Confirm from '@/components/Confirm';
import PaginationComponent from '@/components/PaginationComponent';
import { startAcition, urlEmun, renderActionItem, columns } from './const.js';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
interface Datasource {
  list: any[];
  total: number;
}

interface Invitation {
  queryInvitations: (params?: { spaceId: string | (string | null)[] | null; currentPage: number; pageSize: number; type: string; }) => void;
  loading: boolean;
  dataSource: Datasource;
  contentHeight: number;
}

const Index: React.FC<Invitation> = ({ queryInvitations, loading, dataSource, contentHeight }) => {
  // const [dataSource, setDataSource] = useState({ list: [], total: 0 });
  const [column, setcolumns] = useState(columns);

  // const [loading, setLoading] = useState(false);

  // filter 
  const [filterValue, setFilterValue] = useState<{ role?: string | undefined; status?: string | undefined; }>();
  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });

  const { spaceId } = getQueryStringArgs();
  const onOk = useCallback(async (type, params) => {
    const data = await Requests.post(urlEmun?.[type], { ...params, spaceId });
    if (data) {
      Message.success({
        title: $i18n.get({
          id: 'aopf.pages.miniapp.versions.form.submit.msg',
          dm: '提交成功!',
        }),
      });
      queryInvitations({ spaceId, ...paginationValue, type: 'APP_DEVELOPER', ...filterValue })
    }
  }, [spaceId, paginationValue, filterValue]);

  useEffect(() => {
    const actionRender = {
      title: $i18n.get({ id: 'aopf.pages.member.Invitations.columnsAction', dm: '操作' }),
      dataIndex: 'action',
      width: 220,
      cell: (_v, _i, record) => (
        <div style={{ color: 'var(--superapp-primary-1)', display: 'flex', alignItems: 'center', fontSize: '12px', 'whiteSpace': 'nowrap' }}>
          <div
            onClick={() => {
              startAcition?.[record?.status]?.includes('Resend') && onOk('resend', { invitationCode: record?.invitationCode })
            }}
          >
            {renderActionItem({
              icon: 'redo',
              content: $i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionResend',
                dm: '重新发送',
              }),
              abled: startAcition?.[record?.status]?.includes('Resend'),
            })}
          </div>
          <Divider direction="ver" />

          {startAcition?.[record?.status]?.includes('Withdraw')
            ? <Confirm
              trigger={renderActionItem({
                icon: 'undo',
                content: $i18n.get({
                  id: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                  dm: '撤退',
                }),
                abled: startAcition?.[record?.status]?.includes('Withdraw'),
              })}
              dialogTitle={$i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw.messageTitle',
                dm: '撤退',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw.message',
                dm: '确定确定撤退？',
              })}
              width={350}
              onClick={onOk.bind(null, 'withdraw', { invitationCode: record?.invitationCode })}
            />
            : renderActionItem({
              icon: 'undo',
              content: $i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                dm: '撤退',
              }),
              abled: startAcition?.[record?.status]?.includes('Withdraw'),
            })}
        </div>
      ),
    };
    setcolumns([...columns, actionRender]);
  }, [onOk]);


  useEffect(() => {
    queryInvitations({ spaceId, ...paginationValue, type: 'APP_DEVELOPER', ...filterValue });
  }, [paginationValue, queryInvitations, spaceId]);


  return (
    <div>
      <div className="list-content">
        <Table.StickyLock
          columns={column}
          dataSource={dataSource?.list}
          fixedHeader
          maxBodyHeight={contentHeight - 48}
          loading={loading}
          onFilter={(filterParams) => {
            const filter = {}
            for (const [key, value] of Object.entries(filterParams)) {
              if (key === 'extInfo.roleList') {
                filter['role'] = (value as any)?.selectedKeys?.[0]
              } else {
                filter[key] = (value as any)?.selectedKeys?.[0]
              }
            }
            setFilterValue(pre => ({ ...pre, ...filter }))
            setTimeout(() => {
              setPaginationValue(pre => ({ ...pre, currentPage: 1 }))
            }, 0)
          }}
        />
        <div className='pagenation-container'>
          <PaginationComponent
            total={dataSource?.total}
            current={paginationValue?.currentPage}
            pageSize={paginationValue?.pageSize}
            onPageChange={(current, pageSize) => {
              setPaginationValue({
                currentPage: current,
                pageSize,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
